import { gql } from '@apollo/client';

import { REPORT_SCHEDULE_FRAGMENT } from './common';

export const REPORT_COMMON_FIELDS = gql`
  fragment reportCommonFields on BaseReport {
    id
    templateId
    name
    status
    dateRange
    startDate
    endDate
    schedule {
      ...reportScheduleFragment
    }
    exportFormat
    ownerId
    recipients
    lastGeneratedAt
    updatedAt
  }
  ${REPORT_SCHEDULE_FRAGMENT}
`;
